<div class="vendor-form-container">


   <div class="horizontal_tabs">
    <div class="tabs">
      <div class="tab" *ngIf = "(dynamicForm)" (click)="selectTab('itemDetailsSection')">
        <div class="tab_name" [class.tab_name_active]="selectedTab === 'itemDetailsSection'">{{tabHeaderMap.get('itemDetailsSection')}}</div>
        <div class="bottom_border" [class.bottom_border_active]="selectedTab === 'itemDetailsSection'"></div>
      </div>

      <div class="tab" *ngIf="showItemTable" (click)="selectTab('containerDetailsSection')">
        <div class="tab_name" [class.tab_name_active]="selectedTab === 'containerDetailsSection'">{{tabHeaderMap.get('containerDetailsSection')}}</div>
        <div class="bottom_border" [class.bottom_border_active]="selectedTab === 'containerDetailsSection'"></div>
      </div>
    </div>
    <div class="divider"></div>
  </div>

  <div class = "form" [hidden]="selectedTab !== 'itemDetailsSection'">
    <app-dynamic-form
      [formGroup] = "formGroup"
      [formConfig] = "dynamicForm"
    >
    </app-dynamic-form>
  </div>


  <div class="table-section" [hidden]="selectedTab !== 'containerDetailsSection'">

    <div class="table-scroll">
      <app-static-table
      [data]="tableHeaderAndData.data"
      [readOnlyMode]="true"
      [tableMeta]="tableHeaderAndData.headers"
      [showCheckBox]="false"
      [deleteAllowed]="false"
      >
      </app-static-table>
    </div>
  </div>
</div>
